import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../api";
import {
  Box,
  Button,
  Image,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
  useToast,
  VStack
} from "@chakra-ui/react";

const Login = () => {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [error, setError] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const handleLogin = async () => {
    try {
      const response = await api.post("/usuarios/login", { email, senha });
      const { token, user } = response.data;
      localStorage.removeItem("branding_city");
      localStorage.removeItem("branding_cache_v1");
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      if (user?.role && user.role !== "cliente") {
        navigate("/sistema/empresa");
      } else {
        navigate("/sistema/dashboard");
      }
    } catch (err) {
      const apiMessage = err?.response?.data?.error;
      const safeMessage =
        typeof apiMessage === "string"
          ? apiMessage
          : apiMessage?.message || "Credenciais inválidas";
      setError(safeMessage);
    }
  };

  const handlePasswordReset = async () => {
    try {
      await api.post("/usuarios/esqueci-senha", { email: resetEmail });
      toast({
        title: "Verifique seu e-mail",
        description: "Se o e-mail existir, enviaremos as instruções para recuperação.",
        status: "info",
        duration: 4000,
        isClosable: true
      });
      onClose();
    } catch (_err) {
      toast({
        title: "Erro ao enviar recuperação",
        description: "Tente novamente mais tarde.",
        status: "error",
        duration: 4000,
        isClosable: true
      });
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      backgroundImage="url('/sistema/fundo.png')"
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
    >
      <Box bg="white" p={6} borderRadius="lg" boxShadow="lg" width={{ base: "90%", md: "400px" }} textAlign="center">
        <Image src="/sistema/logo.png" alt="EU Monitoro" mx="auto" mb={3} boxSize="80px" />
        <Text fontSize="2xl" fontWeight="bold" color="#0b6530">
          EU Monitoro
        </Text>

        <VStack spacing={4} mt={4}>
          {error ? <Text color="red.500">{error}</Text> : null}
          <Input placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Input placeholder="Senha" type="password" value={senha} onChange={(e) => setSenha(e.target.value)} />
          <Button colorScheme="green" onClick={handleLogin} w="full">
            Entrar
          </Button>
          <Text fontSize="sm" color="blue.500" cursor="pointer" onClick={onOpen}>
            Esqueci minha senha
          </Text>
        </VStack>
      </Box>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Recuperação de senha</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text mb={3}>Digite seu e-mail e enviaremos instruções para redefinir sua senha.</Text>
            <Input placeholder="E-mail" value={resetEmail} onChange={(e) => setResetEmail(e.target.value)} />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" onClick={handlePasswordReset}>
              Enviar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default Login;
